import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { switchConfig, tokens } from '../../constants';
import { getCurrentEventControlState } from '../../utils';
var switchStylesAfterState = (props, currentState) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
  var configProps = props === null || props === void 0 ? void 0 : props.config;
  var switchSize = (_b = (_a = configProps === null || configProps === void 0 ? void 0 : configProps.size) === null || _a === void 0 ? void 0 : _a[props.size]) === null || _b === void 0 ? void 0 : _b.switchSize;
  var thumbColor = (_d = (_c = configProps === null || configProps === void 0 ? void 0 : configProps.controlState) === null || _c === void 0 ? void 0 : _c[currentState]) === null || _d === void 0 ? void 0 : _d.thumbColor;
  var trackColor = (_f = (_e = configProps === null || configProps === void 0 ? void 0 : configProps.controlState) === null || _e === void 0 ? void 0 : _e[currentState]) === null || _f === void 0 ? void 0 : _f.trackColor;
  var disabledTrackColor = (_h = (_g = configProps === null || configProps === void 0 ? void 0 : configProps.controlState) === null || _g === void 0 ? void 0 : _g.disabled) === null || _h === void 0 ? void 0 : _h.trackColor;
  var disabledThumbColor = (_k = (_j = configProps === null || configProps === void 0 ? void 0 : configProps.controlState) === null || _j === void 0 ? void 0 : _j.disabled) === null || _k === void 0 ? void 0 : _k.thumbColor;
  return {
    switchSize,
    track: {
      checkedStyles: {
        backgroundColor: trackColor === null || trackColor === void 0 ? void 0 : trackColor.on,
        borderColor: trackColor === null || trackColor === void 0 ? void 0 : trackColor.on
      },
      unCheckedStyles: {
        backgroundColor: trackColor === null || trackColor === void 0 ? void 0 : trackColor.off,
        borderColor: thumbColor === null || thumbColor === void 0 ? void 0 : thumbColor.off
      },
      disabledCheckedStyle: {
        backgroundColor: disabledTrackColor === null || disabledTrackColor === void 0 ? void 0 : disabledTrackColor.on,
        borderColor: disabledTrackColor === null || disabledTrackColor === void 0 ? void 0 : disabledTrackColor.off
      },
      disabledUnCheckedStyle: {
        backgroundColor: disabledTrackColor === null || disabledTrackColor === void 0 ? void 0 : disabledTrackColor.off,
        borderColor: disabledTrackColor === null || disabledTrackColor === void 0 ? void 0 : disabledTrackColor.on
      }
    },
    thumb: {
      checkedStyles: {
        backgroundColor: thumbColor === null || thumbColor === void 0 ? void 0 : thumbColor.on
      },
      unCheckedStyles: {
        backgroundColor: thumbColor === null || thumbColor === void 0 ? void 0 : thumbColor.off
      },
      disabledCheckedStyle: {
        backgroundColor: disabledThumbColor === null || disabledThumbColor === void 0 ? void 0 : disabledThumbColor.on
      },
      disabledUnCheckedStyle: {
        backgroundColor: disabledThumbColor === null || disabledThumbColor === void 0 ? void 0 : disabledThumbColor.off
      }
    }
  };
};
export var getTrackStyle = (props, event, fadeAnim) => {
  var disabled = props.disabled,
    checked = props.checked;
  var controlState = getCurrentEventControlState(event, props === null || props === void 0 ? void 0 : props.controlState);
  var _switchStylesAfterSta = switchStylesAfterState(props, controlState),
    switchSize = _switchStylesAfterSta.switchSize,
    track = _switchStylesAfterSta.track;
  return StyleSheet.create({
    track: Object.assign(Object.assign(Object.assign(Object.assign({
      height: switchSize * 0.6,
      width: switchSize,
      borderRadius: 1.35 * switchSize,
      borderWidth: 1,
      alignItems: 'center',
      justifyContent: 'flex-start',
      flexDirection: 'row'
    }, checked && !disabled && track.checkedStyles), checked && disabled && track.disabledCheckedStyle), !checked && disabled && track.disabledUnCheckedStyle), !checked && !disabled && track.unCheckedStyles),
    thumb: getThumbStyle(props, controlState, fadeAnim)
  });
};
export var getThumbStyle = (props, currentState, fadeAnim) => {
  var disabled = props.disabled,
    checked = props.checked;
  var _switchStylesAfterSta2 = switchStylesAfterState(props, currentState),
    switchSize = _switchStylesAfterSta2.switchSize,
    thumb = _switchStylesAfterSta2.thumb;
  return Object.assign(Object.assign(Object.assign(Object.assign({
    width: switchSize / 2,
    height: switchSize / 2,
    borderRadius: switchSize * 2,
    transform: [{
      translateX: fadeAnim
    }],
    zIndex: -1,
    margin: tokens.spacing.SPACING_1
  }, checked && !disabled && thumb.checkedStyles), checked && disabled && thumb.disabledCheckedStyle), !checked && disabled && thumb.disabledUnCheckedStyle), !checked && !disabled && thumb.unCheckedStyles);
};
export var getSwitchStyles = () => {
  var _tokens$spacing = tokens.spacing,
    SPACING_4 = _tokens$spacing.SPACING_4,
    SPACING_8 = _tokens$spacing.SPACING_8;
  return StyleSheet.create({
    parentContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    contextBody: {
      flex: 1,
      marginRight: SPACING_8
    },
    subTitle: {
      marginTop: SPACING_4
    },
    switchContainer: {
      flexShrink: 0
    }
  });
};
export var getSwitchProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(switchConfig === null || switchConfig === void 0 ? void 0 : switchConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.switch) === null || _a === void 0 ? void 0 : _a[theme]);
  var controlState = (props === null || props === void 0 ? void 0 : props.disabled) && 'disabled' || (props === null || props === void 0 ? void 0 : props.controlState) || (configProps === null || configProps === void 0 ? void 0 : configProps.controlState);
  return Object.assign(Object.assign(Object.assign({
    theme
  }, configProps), props), {
    controlState
  });
};